import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const GoogleAuthSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    // Get user data from URL query parameters
    const params = new URLSearchParams(location.search);
    const userParam = params.get('user');
    
    if (userParam) {
      try {
        const userData = JSON.parse(decodeURIComponent(userParam));
        
        // Store user data in localStorage
        localStorage.setItem("customer", JSON.stringify(userData));
        
        // Show success message
        toast.success("Logged in successfully with Google!");
        
        // Redirect to home page or previous page
        const fromGuestOrder = localStorage.getItem("guestOrderId");
        if (fromGuestOrder) {
          // If user came from guest order, redirect to orders page
          navigate("/my-orders");
        } else {
          // Otherwise redirect to home page
          navigate("/");
        }
        
        // Reload the page to ensure all components are updated with the new user data
        window.location.reload();
      } catch (error) {
        console.error("Error parsing user data:", error);
        toast.error("Authentication failed. Please try again.");
        navigate("/login");
      }
    } else {
      toast.error("Authentication failed. Please try again.");
      navigate("/login");
    }
  }, [navigate, location.search]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-yellow-50 to-red-50 flex items-center justify-center">
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-red-500 to-red-600 rounded-full mb-4 shadow-lg">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Processing Google Sign-In</h2>
        <p className="text-gray-600">Please wait while we complete your authentication...</p>
      </div>
    </div>
  );
};

export default GoogleAuthSuccess;